import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../constants";

/**
 * Lightweight hook to fetch the authenticated user's trial status.
 * Returns { trial, locked } where `locked` is true when the user
 * is past their 72h trial and not on the lifetime plan.
 */
export function useTrialStatus() {
  const [trial, setTrial] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    axios
      .get(`${API}/auth/trial-status`, { withCredentials: true, headers })
      .then((res) => setTrial(res.data))
      .catch(() => setTrial(null));
  }, []);

  const locked = !!(trial && trial.status !== "lifetime" && trial.expired);
  return { trial, locked };
}
